import { render, staticRenderFns } from "./ProgramTable.vue?vue&type=template&id=256cceda&scoped=true"
import script from "./ProgramTable.vue?vue&type=script&lang=js"
export * from "./ProgramTable.vue?vue&type=script&lang=js"
import style0 from "./ProgramTable.vue?vue&type=style&index=0&id=256cceda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256cceda",
  null
  
)

export default component.exports